 import { AlignCenter, AlignLeft, AlignRight, Apple, ArrowLeftRight, ArrowUpDown, Circle, FileSpreadsheet, Frame, GalleryVertical, GalleryVerticalEnd, Grid2x2Check, Hash, Languages, LanguagesIcon, LaptopMinimal, LayoutList, Minus, NotepadText, Palette, Plus, SmartphoneCharging, Square, Squircle, TabletSmartphone } from "lucide-react";
 import React, { useEffect, useRef, useState } from "react";
 import { useDispatch } from "react-redux";
 import ImagesUI from "../../../UI/ImagesUI";
 
 import fallback_img from "../../../img/fallback_img.jpg"
 import loading_img from "../../../img/loadingImg.jpg"
 import Toggle from "../../../UI/Toggle";
 import RangeSlider from "../../../UI/RangeSlider";
 import RangeSliderBasic from "../../../UI/RangeSliderBasic";
 import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
 import ColorPicker from "../../../UI/ColorPicker/Colorpicker";
 import ColorPickerDynamic from "../../../UI/ColorPicker/ColorPickerDynamic";
 const ListUISettingsLoading = ({ setItemArrCurrent,images,sendBackImagesArray,dynamicId,scrollItems, setScrollItems,columnsList, setColumnsList,fontFamily, setFontFamily
     ,iWidth, setiWidth,iHeight, setiHeight,
     titleFontSize, setTitleFontSize,subTitleFontSize, setSubTitleFontSize,titleFontColor, setTitleFontColor,subTitleFontColor, setSubTitleFontColor,
     titleFontWeight, setTitleFontWeight,subTitleFontWeight, setSubTitleFontWeight,
     borderRadius, setBorderRadius,marginLeft, setmarginLeft
     ,marginTop, setmarginTop,marginBottom, setmarginBottom,imarginLeft, setimarginLeft,imarginTop, setimarginTop,aspectRatio, setAspectRatio,
     showTitle, setShowTitle, showSubTitle, setShowSubTitle,textAlignment, setTextAlignment,textPosition, setTextPosition,
     applyOverlay,setApplyOverlay,overlayTitleFontColor, setOverlayTitleFontColor,overlayBG, setOverlayBG,
 
     
 
 absoluteHorizontal,setAbsoluteHorizontal,absoluteVertical,setAbsoluteVertical,
 absoluteHorizontalMargin,setAbsoluteHorizontalMargin,absoluteVerticalMargin,setAbsoluteVerticalMargin,
   
 itemVisibility,setItemVisibility,
 itemBackground, setItemBackground,setItemArr
 }) => {  const dispatch = useDispatch(); 
       const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
     ;
    
    
    return(<div><div style={{background:"#ffffff",display:"flex",justifyContent:"space-around",borderRadius:"15px",marginBottom:"10px"}}>  
                    <div 
                        style={{background:"#ffffff",width:"100px",color:"#222222",borderRadius:"15px",fontSize:"16px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                 
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Contents</div>         
                 <div style={{background:"rgba(144, 202, 249,1)",width:"100px",color:"#fff",borderRadius:"15px",fontSize:"16px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Settings</div>         
               </div>
               <div className="appSettingsScroller"  >
              
           <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"0px",
                            paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                             Set Columns & Background</div> 
                              <div style={{background:"#ffffff",display:"grid", gridTemplateColumns: "35% 45% 15%" ,borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
                               <div style={{fontSize:"18px",fontWeight:"bold",padding:"8px",paddingTop:"15px"}}>Columns</div>         
                          <div style={{margin: '5px' ,paddingLeft:"0px",width:"90px", display:"grid", gridTemplateColumns: "50% 30% 0%" ,alignItems:"center"  }}>
            <Minus onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
                   alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
               <input onMouseEnter={handleMouseEnter} disabled
                onMouseLeave={handleMouseLeave}  value={""} type="number"
                      style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",
                       padding:"0px",marginLeft:"5px",fontSize:"20px",color:"#555555 ",background:"#fff",fontWeight:"bolder",marginTop:"0px",}}
                 />  <Plus onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave}   style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",
                   alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
                   
                   
                   
                   </div> 
                   
                   <div style={{paddingTop:"10px"}}> <label onMouseEnter={
                                                        ()=>handleMouseEnter("#fff","#333","")}
                                         onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                       <div style={{display:"flex",justifyContent:"space-between"}} >
                                                       
                                                        <Palette onMouseEnter={handleMouseEnter}
                                                                                onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                
                                                        </div> 
                                         <input type="checkbox" title="Color Theme"   checked={""}
                              className="input-textbox"  value={""}  name="palletBG1"  
                              />
                                   <span class={"boxCardBorder-two"}></span> </label>
          
            <div style={{position:"absolute",right:"0px",top:"110px",zIndex:"9999999"}}>
           </div></div>
                   
                   </div>
           

                 <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                             paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                              Item Display Settings</div>         
                     
                             <div style={{borderRadius:"15px",paddingBottom:"10px",marginTop:"5px",padding:"0px",}}>
                                  
            
                         <div className="" style={{borderRadius:"0px",margin:"5px",paddingBottom:"0px",
                          height:"80px"}}> 
                   <div >  
                       <div style={{}}> 
                        <div class="input-card-outer"style={{
                             
                              transition: 'transform 3s ease, opacity 3s ease',
                            borderRadius:"25px",padding:"5px"}} >
                                                      
                                                      <div class=" gridFiftyFixed">
                                                              <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                                         <div style={{display:"flex",justifyContent:"space-between"}} >
                                                          
                                                         <Grid2x2Check onMouseEnter={handleMouseEnter}
                                                                                 onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                                  
                                                                                 }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                                 <div style={{position:"relative"}}>
                                                            Grid
                                                          </div>  </div>  
                                          <input type="radio" title="Set As Years"   checked={""}
                               className="input-textbox"  value={"Grid"}  name="scrollStatus1"  
                              />
                                    <span class={"boxCardBorder"}></span> </label>
                                    <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                        
                                                         <ArrowLeftRight onMouseEnter={handleMouseEnter}
                                                                                 onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                                 
                                                                                   <div style={{position:"relative"}}>Scroll</div>
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="Scroll"  name="scrollStatus1"  
                              />
                                    <span class={"boxCardBorder"}></span> </label> 
                                    </div>  </div></div> </div>
                                    
                                                                </div>
            
                             </div>
                               <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",
                             paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                              Image Settings</div>  
            
            <div style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"10px",}}>
                   
                           
                         <div className="" style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginBottom:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
                    
                                  
                        
                                    <div style={{display:"flex",justifyContent:"space-around"}}><h4>{"Radius "} </h4>
                                    <div style={{display:"flex",justifyContent:"space-around"}}>
                        <RangeSliderBorderRadius resolution={"px"}  setSliderVal={(val)=>{ }} 
                           sliderVal={50} />
                          <div style={{height:"50px" ,width:"90px"}}> 
                        <div class="input-card-outer"style={{
                             
                              transition: 'transform 3s ease, opacity 3s ease',
                            borderRadius:"25px",padding:"0px"}} >
                                                      
                                                      <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                              
                                     
                                      <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} >
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                      %
                                                                                 
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="%"  name="resolution1"  
                              />
                                    <span class={"boxCardBorder-two"}></span> </label> 
                                      <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                        px                        
                                                                                 
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="px"  name="resolution1"  
                               />
                                    <span class={"boxCardBorder-two"}></span> </label> 
                                    </div>  </div></div></div>
                           </div> 
                           <div style={{height:"60px"}}> 
                        <div class="input-card-outer"style={{
                             
                              transition: 'transform 3s ease, opacity 3s ease',
                            borderRadius:"25px",padding:"0px"}} >
                                                      
                                                      <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                           <h4>{"Corner Type  "} </h4>   <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                         <div style={{display:"flex",justifyContent:"space-between"}} >
                                                          
                                                       <Square color={"#333"} size={30}/>
                                                                                  </div>  
                                          <input type="radio" title="Set As Years"   checked={""}
                               className="input-textbox"  value={"square"}  name="cornerType1"  
                               />
                                    <span class={"boxCardBorder-two"}></span> </label>
                                    <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                        
                                                        <Squircle color={"#333"} size={30}/>                       
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="squircle"  name="cornerType1"  
                              />
                                    <span class={"boxCardBorder-two"}></span> </label> 
                                      <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                           <Circle color={"#333"} size={30}/>
                                                                                 
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="circle"  name="cornerType1"  
                              />
                                    <span class={"boxCardBorder-two"}></span> </label> 
                                     
                                    </div>  </div></div> 
            
                                    <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                           <h4>{"Crop Ratio"} </h4>
                       <div style={{height:"110px"}}> 
                        <div class="input-card-outer"style={{
                             
                              transition: 'transform 3s ease, opacity 3s ease',
                            borderRadius:"25px",padding:"0px"}} >
                                                      
                                                      <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                              <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                         <div style={{display:"flex",justifyContent:"space-between"}} >
                                                          
                                                         2/1
                                                                                  </div>  
                                          <input type="radio" title="Set As Years"   checked={""}
                               className="input-textbox"  value={"2/1"}  name="aspectRatio1"  
                              />
                                    <span class={"boxCardBorder-two"}></span> </label>
                                    <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                        
                                                        1/1                        
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="1/1"  name="aspectRatio1"  
                             />
                                    <span class={"boxCardBorder-two"}></span> </label> 
                                      <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                        3/4
                                                                                 
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="3/4"  name="aspectRatio1"  
                             />
                                    <span class={"boxCardBorder-two"}></span> </label> 
                                      <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                         4/3                        
                                                                                 
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="4/3"  name="aspectRatio1"  
                              />
                                    <span class={"boxCardBorder-two"}></span> </label> 
                                    </div>  </div>
                                     <div class="input-card-outer"style={{
                             
                              transition: 'transform 3s ease, opacity 3s ease',
                            borderRadius:"25px",padding:"0px"}} >
                                                      
                                                      <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                              <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                         <div style={{display:"flex",justifyContent:"space-between"}} >
                                                          
                                                         4/1
                                                                                  </div>  
                                          <input type="radio" title="Set As Years"   checked={""}
                               className="input-textbox"  value={"4/1"}  name="aspectRatio1"  
                             />
                                    <span class={"boxCardBorder-two"}></span> </label>
                                    
                                      <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                        9/16
                                                                                 
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="9/16"  name="aspectRatio1"  
                           />
                                    <span class={"boxCardBorder-two"}></span> </label> 
                                      <label onMouseEnter={
                                                         ()=>handleMouseEnter("#fff","#333","")}
                                          onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                        <div style={{display:"flex",justifyContent:"space-between"}} >
                                                         16/9                      
                                                                                 
                                                         </div> 
                                          <input type="radio" title="Color Theme"   checked={""}
                               className="input-textbox"  value="16/9"  name="aspectRatio1"  
                              />
                                    <span class={"boxCardBorder-two"}></span> </label> 
                                    </div>  </div>
                                    </div> </div>
                                                                </div></div>
  <div style={{height:"610px"}}> </div>

                                                                 </div> </div>)

                                                                
};


export default ListUISettingsLoading;